export const AUTO_MAPPING_SEARCH_STATUS = {
  SUCCESS: 'SEARCH_SUCCESS',
  FAIL: 'SEARCH_FAIL',
};

export const MAPPING_FILTERS_TYPES = {
  DROPDOWN: 'dropdown',
};

export const MAPPING_FILTERS_CONFIG_KEY = 'mapping_filters';

export const MAPPING_REJECTION_REASONS_KEY = 'mapping_rejection_reasons';

export const MAPPING_STATES_OPTIONS = [
  {
    text: 'Pending',
    key: 'PENDING',
    value: 'PENDING',
  },
  {
    text: 'Failed',
    key: 'FAILED',
    value: 'FAILED',
  },
  {
    text: 'Auto mapped',
    key: 'AUTO_MAPPED',
    value: 'AUTO_MAPPED',
  },
  {
    text: 'Manual mapped',
    key: 'MANUAL_MAPPED',
    value: 'MANUAL_MAPPED',
  },
  {
    text: 'Search pending',
    key: 'SEARCH_PENDING',
    value: 'SEARCH_PENDING',
  },
  {
    text: 'Search success',
    key: 'SEARCH_SUCCESS',
    value: 'SEARCH_SUCCESS',
  },
  {
    text: 'Search failed',
    key: 'SEARCH_FAILED',
    value: 'SEARCH_FAILED',
  },
];
